// Dependency-free variant of `sleep` from `src/lib/utils.ts`, which pulls the
// rematch store graph and cannot be imported from isolated unit-test targets.
export const sleep = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms));
